import { initShoppingBag } from '../slice/order.slice';

export const initShoppingBagEvent = initShoppingBag.fulfilled;
